import { Loader2 } from 'lucide-react';

export function PageSpinner() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-accent-500" />
      <span className="text-xs text-fg-lo">Lade …</span>
    </div>
  );
}
